export default __webpack_public_path__ + "static/SRC BS001 - Product Specifications & Technical Data-069668ce5d06f9488848768f8b973afd.pdf";